import React from 'react';

// AsianRisk brand mark (user-supplied cyan dragon poker-chip logo).
// `size` sets default width/height; a width/height className can override it responsively.
export default function Logo({ size = 64, glow = true, className = '' }) {
  return (
    <img
      src="/assets/asianrisk-logo.png"
      alt="AsianRisk logo"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        filter: glow ? 'drop-shadow(0 0 16px rgba(0,217,255,0.55))' : 'none',
      }}
    />
  );
}
